import React from 'react';

import { useSelector } from 'react-redux';

import { Box } from '@atlaskit/primitives';

import {
  extensionTitle,
  ForgeRepoCodeOverviewPanelExtensionPoint,
  ForgeRepoCodeOverviewPanelExtensionPointProps,
} from 'src/components/forge-ui/src';
import { ExpandablePanel } from 'src/components/sidebar/src/expandable-panel';
import { useForgeBridge } from 'src/hooks/forge-bridge';
import * as styles from 'src/sections/global/components/page.style';
import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { getCurrentUser } from 'src/selectors/user-selectors';

export type ForgeRepoCodeOverviewPanelProps = Omit<
  ForgeRepoCodeOverviewPanelExtensionPointProps,
  'WrapperComponent'
>;

const FORGE_REPO_CODE_OVERVIEW_PANEL_COLLAPSED_LOCALSTORAGE_KEY =
  'forge.repo.code.overview.panel.collapsed';

const ForgeRepoCodeOverviewPanelWrapper: ForgeRepoCodeOverviewPanelExtensionPointProps['WrapperComponent'] =
  ({ app, children }) => {
    const Header = (
      <styles.PanelHeader>{extensionTitle(app)}</styles.PanelHeader>
    );

    return (
      <Box as="section">
        <ExpandablePanel
          header={Header}
          storageKey={`${FORGE_REPO_CODE_OVERVIEW_PANEL_COLLAPSED_LOCALSTORAGE_KEY}.${app.id}.${app.environmentId}`}
        >
          {children}
        </ExpandablePanel>
      </Box>
    );
  };

const ForgeRepoCodeOverviewPanel = (): JSX.Element | null => {
  const forgeBridgeProps = useForgeBridge();
  const repository = useSelector(getCurrentRepository);
  const currentUser = useSelector(getCurrentUser) || undefined;

  if (repository && repository.workspace)
    return (
      <ForgeRepoCodeOverviewPanelExtensionPoint
        bridge={forgeBridgeProps}
        currentUser={currentUser}
        repository={repository}
        workspace={repository.workspace}
        WrapperComponent={ForgeRepoCodeOverviewPanelWrapper}
      />
    );
  return null;
};

// Default export is needed because this is lazy loaded by LazyForgeRepoCodeOverviewPanel
export default ForgeRepoCodeOverviewPanel;
